import { render, staticRenderFns } from "./KnowledgeBaseDetail.vue?vue&type=template&id=60d77c8c&scoped=true&"
import script from "./KnowledgeBaseDetail.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBaseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBaseDetail.vue?vue&type=style&index=0&id=60d77c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d77c8c",
  null
  
)

export default component.exports